import { areCloseScalar } from "features/LinearAlgebra/vectorUtils";

export function checkIfAngleMeasureShouldBeHidden(angle: number) {
  return areCloseScalar(0, angle % 90);
}
